'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Up = require('./Up');

var _Up2 = _interopRequireDefault(_Up);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Up2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Carets/Up/index.js
// module id = 168
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15